import { useEffect, useRef, useState } from 'react';

import { ARROW_H_OFFSET_PX } from './styles';

export const useScrollState = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const update = () => {
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    update();
    el.addEventListener('scroll', update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);

    return () => {
      el.removeEventListener('scroll', update);
      ro.disconnect();
    };
  }, []);

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) return;

    const update = () => {
      const rect = el.getBoundingClientRect();
      const left = Math.max(0, Math.min(rect.left, ARROW_H_OFFSET_PX));
      const right = Math.max(0, Math.min(window.innerWidth - rect.right, ARROW_H_OFFSET_PX));
      el.style.setProperty('--arrow-left', `-${left}px`);
      el.style.setProperty('--arrow-right', `-${right}px`);
    };

    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return { canScrollLeft, canScrollRight, containerRef, wrapperRef };
};
